import React, { useEffect, useState } from "react";
import { PiDotsThreeVerticalBold } from "react-icons/pi";
import { Dropdown, Menu, Modal, Space } from "antd";
import SideBar from "../components/sidebar/SideBar";
import Header from "../components/header/Header";
import { ToastContainer, toast } from "react-toastify";
import { Slide, Zoom, Flip, Bounce } from "react-toastify";
import DashboardLayout from "../components/layout";

const Index = () => {
  const obj = {
    ative: true,
    content: "My Warehouse",
  };
  const [modalIsOpen, setIsOpen] = useState(false);
  // show edit,del on click
  const [menuVisible, setMenuVisible] = useState(false);
  // show delete modal state
  const [showDeleteConfirmationModal, setShowDeleteConfirmationModal] =
    useState(false);

  // for edit and delete functionality
  const handleMenuClick = ({ key }) => {
    if (key === key) {
      // Handle the edit action
    } else if (key === key) {
      // Handle the delete action
      setShowDeleteConfirmationModal(true);
    }
    setMenuVisible(false); // Close the menu after the click
  };
  // close action buttons if click anywhere outside
  useEffect(() => {
    const closeMenuOnOutsideClick = (event) => {
      if (menuVisible) {
        const dropdownContainer = document.querySelector(".ant-dropdown");
        if (dropdownContainer && !dropdownContainer.contains(event.target)) {
          setMenuVisible(false); // Close the menu if the click is outside the dropdown
        }
      }
    };

    document.body.addEventListener("click", closeMenuOnOutsideClick);

    return () => {
      document.body.removeEventListener("click", closeMenuOnOutsideClick);
    };
  }, [menuVisible]);

  const notify = () => toast("5 days left");

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        transition={Flip}
        draggable
        limit={2}
        pauseOnHover={false}
      />
      <DashboardLayout>
        {/* <div className="hidden h-full border-r sm:block ">
          <SideBar obj={obj} />
        </div> */}
        <div className="w-full">
          <Header title="My Warehouse" />

          <div className="p-5 bg-[#eaeff6]">
            {/* <Table checkbox={true} headings={['Processing Status', 'Ship Status', 'Order Number', 'Name', 'Country', 'Order Date', 'Action']} /> */}
            <div className="flex items-center justify-between px-0 py-3 mt-4 bg-white rounded-md md:py-5">
              {/* for web */}
              <div className="hidden w-full sm:inline">
                <table className="w-full text-sm text-center ">
                  <thead className="font-normal ">
                    <tr className="border-b-2 text-[#000000A3] ">
                      <th className="p-1" onClick={notify}>
                        Customer
                      </th>
                      <th className="p-1">Reference</th>
                      <th className="p-1">Shipment Status</th>
                      <th className="p-1">Ship from</th>
                      <th className="p-1">ship to</th>
                      <th className="p-1">Dimension</th>
                      <th className="p-1">Order Date</th>
                      <th className="p-1">Action</th>
                    </tr>
                  </thead>
                  <tbody className="">
                    {[1, 2, 3, 4, 5].map((index) => (
                      <tr className="border-b-2 ">
                        <td className="p-1">Name</td>
                        <td className="p-1">Ready to process</td>
                        <td className="p-1">Status</td>
                        <td className="p-1">address from</td>
                        <td className="p-1">address to</td>
                        <td className="p-1">dimension</td>
                        <td className="p-1">14 Oct, 2023</td>
                        <td className="p-1">
                          <Dropdown
                            overlay={
                              <Menu onClick={handleMenuClick}>
                                <Menu.Item key={index + 1}>
                                  <Space>Edit</Space>
                                </Menu.Item>
                                <Menu.Item key={index + 2}>
                                  <Space>Delete</Space>
                                </Menu.Item>
                              </Menu>
                            }
                            visible={menuVisible}
                            trigger={["click"]}
                          >
                            <a
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation(); // Stop the click event from propagating to the body
                                setMenuVisible(true); // Open the menu on click
                              }}
                            >
                              <Space>
                                <button className="border p-1 rounded-md border-[#053F92]">
                                  <PiDotsThreeVerticalBold size={20} />
                                </button>
                              </Space>
                            </a>
                          </Dropdown>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* for mobile */}
              <div className="w-full p-4 sm:hidden">
                {/* 1st card */}
                <div className="flex items-center justify-between w-full pb-3 mt-3 wrap">
                  <div className="flex-wrap">
                    <p className="text-lg font-semibold">Customer</p>
                    <p className="font-[600] text-blue-600 text-lg max-w-xs break-all">
                      Name
                    </p>
                  </div>
                  <div className="flex-wrap text-end">
                    <p className="text-lg font-semibold">Reference</p>
                    <p className="font-[600] text-blue-600 text-lg max-w-xs break-all">
                      Ready to process
                    </p>
                  </div>
                </div>
                <div className="flex items-center justify-between w-full pb-3 wrap">
                  <div className="flex-wrap">
                    <p className="text-lg font-semibold">Ship from</p>
                    <p className="font-[600] text-blue-600 text-lg max-w-xs break-all">
                      address from
                    </p>
                  </div>
                  <div className="flex-wrap text-end">
                    <p className="text-lg font-semibold">ship to</p>
                    <p className="font-[600] text-blue-600 text-lg max-w-xs break-all">
                      address to
                    </p>
                  </div>
                </div>
                <div className="flex items-center justify-between w-full pb-3 wrap">
                  <div className="flex-wrap">
                    <p className="text-lg font-semibold">Dimension</p>
                    <p className="font-[600] text-blue-600 text-lg max-w-xs break-all">
                      dimension
                    </p>
                  </div>
                  <div className="flex-wrap text-end">
                    <p className="text-lg font-semibold">Country</p>
                    <p className="font-[600] text-blue-600 text-lg max-w-xs break-all">
                      USA
                    </p>
                  </div>
                </div>
                <div className="flex items-center justify-between w-full pb-3 wrap">
                  <div className="flex-wrap">
                    <p className="text-lg font-semibold">Order Date</p>
                    <p className="font-[600] text-blue-600 text-lg max-w-xs break-all">
                      14 Oct, 2023
                    </p>
                  </div>
                </div>
                {/* Actions */}
                <div className="flex justify-between  border-b border-[#A51F6C] pb-5">
                  <div
                    onClick={() => setShowDeleteConfirmationModal(true)}
                    className="flex-wrap"
                  >
                    <button
                      className="border  border-cus-red rounded-md p-1 
                                                text-cus-red bg-[#fae4e1] w-28"
                    >
                      Delete
                    </button>
                  </div>
                  <div className="flex-wrap">
                    <button
                      className="border border-cus-green rounded-md p-1 ms-2
                                                 text-cus-green bg-[#e2f8d5] w-28"
                    >
                      Edit
                    </button>
                  </div>
                </div>

                {/* 2ndcard */}
              </div>
            </div>
          </div>
        </div>
      </DashboardLayout>

      {/* modal for delete from antd */}
      <Modal
        title="Confirm Deletion"
        open={showDeleteConfirmationModal}
        onCancel={() => setShowDeleteConfirmationModal(false)}
        // onOk={() => {
        // console.log("DELETE", selectedProduct);
        // deleteMutation.mutate(selectedProductId) }}
        okText="Yes"
        cancelText="No"
        okButtonProps={{
          style: { backgroundColor: "#D83535", color: "#FFFFFF" },
        }}
      >
        <p>Are you sure you want to delete the selected shipment?</p>
      </Modal>
    </>
  );
};

export default Index;
